import React from 'react';

const ArrowLeft = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<polygon
				points="21.6 10.99 20.11 9.5 6.14 9.5 13.01 2.63 10.89 .51 2.52 8.88 2.52 8.88 .4 11 2.52 13.12 2.52 13.12 10.89 21.49 13.01 19.37 6.14 12.5 20.11 12.5 21.6 10.99"
			/>
		</g>
	</svg>
);

export default ArrowLeft;
